import { FREELANCECLIENTINTERVIEWSCHEDULE } from "../../ENVIRONMENT";

// api for freelance interview schedule
async function freeinterviewSchedule(token, data) {
  return await fetch(FREELANCECLIENTINTERVIEWSCHEDULE, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        token ? token : sessionStorage.getItem("token")
      }`,
    },
    body: JSON.stringify(data),
  });
}

export { freeinterviewSchedule };
